import { useAuthStore } from '~/store/auth'
import { useWebStore } from '~/store/web'

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore()
  if (!authStore.user) return

  const webStore = useWebStore()
  webStore.syncFromAuth()

  if (authStore.user.is_admin_role) return

  const requiresWeb = ['/web-edit', '/contact']
  const needsWeb = requiresWeb.some((p) => to.path === p || to.path.startsWith(p + '/'))
  if (needsWeb && !webStore.selectedWebsite) {
    return navigateTo('/account/password')
  }
})
